// Common FIFA / football country codes (lowercased ISO-2 used by flagcdn.com)
// England: gb-eng; Scotland: gb-sct; Wales: gb-wls; Northern Ireland: gb-nir
export const COUNTRIES = [
  { code: "dz", name: "Algeria" },
  { code: "ar", name: "Argentina" },
  { code: "au", name: "Australia" },
  { code: "at", name: "Austria" },
  { code: "be", name: "Belgium" },
  { code: "ba", name: "Bosnia & Herzegovina" },
  { code: "br", name: "Brazil" },
  { code: "cv", name: "Cabo Verde" },
  { code: "ca", name: "Canada" },
  { code: "cl", name: "Chile" },
  { code: "co", name: "Colombia" },
  { code: "ci", name: "Côte d'Ivoire" },
  { code: "hr", name: "Croatia" },
  { code: "cw", name: "Curaçao" },
  { code: "cz", name: "Czechia" },
  { code: "dk", name: "Denmark" },
  { code: "cd", name: "DR Congo" },
  { code: "ec", name: "Ecuador" },
  { code: "eg", name: "Egypt" },
  { code: "gb-eng", name: "England" },
  { code: "fr", name: "France" },
  { code: "de", name: "Germany" },
  { code: "gh", name: "Ghana" },
  { code: "ht", name: "Haiti" },
  { code: "ir", name: "Iran" },
  { code: "iq", name: "Iraq" },
  { code: "it", name: "Italy" },
  { code: "jp", name: "Japan" },
  { code: "jo", name: "Jordan" },
  { code: "kr", name: "Korea Republic" },
  { code: "mx", name: "Mexico" },
  { code: "ma", name: "Morocco" },
  { code: "nl", name: "Netherlands" },
  { code: "nz", name: "New Zealand" },
  { code: "ng", name: "Nigeria" },
  { code: "gb-nir", name: "Northern Ireland" },
  { code: "no", name: "Norway" },
  { code: "pa", name: "Panama" },
  { code: "py", name: "Paraguay" },
  { code: "pe", name: "Peru" },
  { code: "pl", name: "Poland" },
  { code: "pt", name: "Portugal" },
  { code: "qa", name: "Qatar" },
  { code: "ro", name: "Romania" },
  { code: "sa", name: "Saudi Arabia" },
  { code: "gb-sct", name: "Scotland" },
  { code: "sn", name: "Senegal" },
  { code: "rs", name: "Serbia" },
  { code: "za", name: "South Africa" },
  { code: "es", name: "Spain" },
  { code: "se", name: "Sweden" },
  { code: "ch", name: "Switzerland" },
  { code: "tn", name: "Tunisia" },
  { code: "tr", name: "Türkiye" },
  { code: "ua", name: "Ukraine" },
  { code: "uy", name: "Uruguay" },
  { code: "us", name: "United States" },
  { code: "uz", name: "Uzbekistan" },
  { code: "gb-wls", name: "Wales" },
];

export const flagUrl = (code) => `https://flagcdn.com/w160/${code}.png`;
